import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircleIcon, ArrowRightIcon } from 'lucide-react';
import type { Vehicle } from '../../../types/vehicle';
import { Badge } from '../../ui/Badge';
import { cardWhatsappMessage, formatKm, formatPrice, whatsappLink } from '../../../utils/vehicles';
import { onImageError } from '../../../utils/drive';
export function CompareCard({
  vehicle,
  rank
}: {
  vehicle: Vehicle;
  rank: number;
}) {
  const title = `${vehicle.marca} ${vehicle.modelo}`;
  return <article className={`flex flex-col overflow-hidden rounded-2xl border bg-surface2/50 transition-[border-color,transform] duration-200 ease-smooth hover:-translate-y-0.5 ${rank === 0 ? 'border-neon/60' : 'border-line hover:border-neon/50'}`} data-id="element-401" data-mp="17mktckamqmhz">
      <div className="relative aspect-[16/10] overflow-hidden bg-ink" data-id="element-402" data-mp="3edivnfc4cuon">
        <img src={vehicle.imagenPrincipal} alt={`${title} ${vehicle.version} ${vehicle.anio}`} loading="lazy" onError={onImageError} referrerPolicy="no-referrer" className="h-full w-full object-cover" data-id="element-403" data-mp="3eges0z8bjbaz" />
        <div className="absolute inset-x-0 top-0 flex flex-wrap gap-1.5 p-3" data-id="element-404" data-mp="3sr6ehqc1xvto">
          {rank === 0 ? <Badge tone="neon" data-id="element-405" data-mp="aljy37qxxto7">Mejor coincidencia</Badge> : null}
          {vehicle.oportunidad ? <Badge tone="amber" data-id="element-406" data-mp="5juirfwoqtub">Oportunidad</Badge> : null}
          {vehicle.destacado && rank !== 0 ? <Badge tone="neon" data-id="element-407" data-mp="jjltn7rwnu43">Destacado</Badge> : null}
        </div>
      </div>

      <div className="flex flex-1 flex-col p-5" data-id="element-408" data-mp="fjlgdqgjloym">
        <h4 className="text-[17px] font-bold leading-snug text-white" data-id="element-409" data-mp="fitj8b7arj68">
          {title}
          <span className="block text-[13px] font-medium text-mist" data-id="element-410" data-mp="t9yoptxcj5oh">
            {vehicle.version}
          </span>
        </h4>
        <p className="mt-3 text-[22px] font-extrabold tracking-tight text-white" data-id="element-411" data-mp="odq1dt8zw668">
          {formatPrice(vehicle.precio, vehicle.moneda)}
        </p>
        <p className="mt-1 text-[13px] text-mist" data-id="element-412" data-mp="yamdsa20lcg2">
          {vehicle.anio} · {formatKm(vehicle.kilometraje)} · {vehicle.tipo}
        </p>
        <p className="mt-1 text-[13px] text-mist" data-id="element-413" data-mp="15aoklgddpunq">
          {vehicle.transmision} · {vehicle.combustible}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5" data-id="element-414" data-mp="1faxkb46kxy7v">
          {vehicle.financiacion ? <Badge tone="green" data-id="element-415" data-mp="1f8uk5rbpqopf">Financiación</Badge> : null}
          {vehicle.permuta ? <Badge data-id="element-416" data-mp="1k38ju5xerhzw">Permuta</Badge> : null}
        </div>

        <div className="mt-auto flex gap-2 pt-5" data-id="element-417" data-mp="1p10l3qjy0ggr">
          <Link to={`/vehiculos/${vehicle.slug}`} className="inline-flex h-10 flex-1 items-center justify-center gap-1.5 rounded-xl border border-line bg-surface2/70 text-[13px] font-semibold text-white transition-colors duration-150 ease-smooth hover:border-neon/70" data-id="element-418" data-mp="1p07fwu0mtz0q">
            Ver detalle
            <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-419" data-mp="22y5mhd8por5o" />
          </Link>
          <a href={whatsappLink(cardWhatsappMessage(vehicle), vehicle.whatsapp)} target="_blank" rel="noopener noreferrer" aria-label={`Consultar esta unidad: ${title} ${vehicle.version}`} className="inline-flex h-10 items-center justify-center gap-1.5 rounded-xl bg-[#1fae5a] px-3.5 text-[13px] font-semibold text-white transition-colors duration-150 ease-smooth hover:bg-[#25c264]" data-id="element-420" data-mp="3pibgmz9a7kg">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-421" data-mp="3ikiqh2uojgw6" />
            Consultar
          </a>
        </div>
      </div>
    </article>;
}